import Styles from './TextAlignSelection.module.scss'
import { LeftButton } from './LeftButton'
import { CenterButton } from './CenterButton'
import { JustifyButton } from './JustifyButton'
import { RightButton } from './RightButton'

export const TextAlignSelection = () => {
  return (
    <div className={Styles.textAlignSelection}>
      <LeftButton />
      <CenterButton />
      <RightButton />
      <JustifyButton />
    </div>
  )
}
